
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
  },
}
